<mat-card>
  <mat-card-header>
    <mat-card-title
      cdkDrag
      cdkDragHandle
      cdkDragRootElement=".cdk-overlay-pane"
    >
      {{ title }}
    </mat-card-title>
  </mat-card-header>

  <!-- Form -->
  <mat-card-content style="margin: 2em 0; max-height: 65vh; overflow: auto">
    @if (formulario) {
      <form
        id="form"
        [formGroup]="formulario"
        (ngSubmit)="enviar()"
        autocomplete="off"
      >
        <mat-form-field>
          <mat-label>Input qr</mat-label>
          <!-- [tabIndex]="-1" -->
          <input
            matInput
            placeholder="Lectura qr"
            formControlName="input"
            (input)="procesarInput()"
          />
        </mat-form-field>
        <!-- Chip Id Control -->
        <mat-form-field>
          <mat-label>MAC</mat-label>
          <input
            [tabIndex]="-1"
            matInput
            placeholder="MAC"
            formControlName="mac"
            required
          />
        </mat-form-field>
        <!-- Etiqueta -->
        <mat-form-field>
          <mat-label>Etiqueta</mat-label>
          <input
            matInput
            placeholder="Etiqueta del control"
            formControlName="etiqueta"
          />
        </mat-form-field>
        <mat-checkbox
          formControlName="incrementar"
          style="margin-bottom: 2em"
          [tabIndex]="-1"
        >
          Incrementar etiqueta automaticamente
        </mat-checkbox>
      </form>
    }
  </mat-card-content>

  <mat-divider />

  <!-- Botones -->
  <mat-card-actions class="gap-3" style="margin: 0.5em">
    <button
      class="botonSpinner"
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="!formulario?.valid || loading"
      form="form"
    >
      <div
        class="loadSpinnerButton"
        [style.display]="loading ? 'flex' : 'none'"
      >
        <mat-spinner
          class="mx-2"
          [diameter]="25"
          mode="indeterminate"
          color="warn"
        />
      </div>
      <span [style.display]="loading ? 'none' : 'block'">Guardar</span>
    </button>

    <button mat-raised-button type="button" (click)="close()" [tabIndex]="-1">
      Volver
    </button>
  </mat-card-actions>

  <!-- Progress Bar  -->
  <mat-card-footer>
    <mat-progress-bar [mode]="loading ? 'indeterminate' : 'determinate'" />
  </mat-card-footer>
</mat-card>
